import { render, staticRenderFns } from "./ColorSelect.vue?vue&type=template&id=7ab36bd9&"
import script from "./ColorSelect.vue?vue&type=script&lang=js&"
export * from "./ColorSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports